import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminDashboard from "@/pages/AdminDashboard";
import SecurityScanner from "@/pages/SecurityScanner";
import SecurityDashboard from "@/pages/SecurityDashboard";
import VisitorRegistry from "@/pages/VisitorRegistry";
import SecurityRegistryHistory from "@/pages/SecurityRegistryHistory";
import Login from "@/pages/Login";
import VisitorHistory from "@/pages/VisitorHistory";
import UserManagement from "@/pages/UserManagement";
import PropertyManagement from "@/pages/PropertyManagement";
import QRDebug from "@/pages/QRDebug";
import TestScanner from "@/pages/TestScanner";
import SecurityScannedHistory from "@/pages/SecurityScannedHistory";
import SecurityVisitorRegistry from "@/pages/SecurityVisitorRegistry";
import SupportForm from "@/pages/SupportForm";
import SupportMessages from "@/pages/SupportMessages";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

// Component to redirect based on user role
const RoleBasedRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'security') {
    return <Navigate to="/security" replace />;
  }

  return <Navigate to="/admin" replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RoleBasedRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/scanner" element={<SecurityScanner />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/security" 
              element={
                <ProtectedRoute>
                  <SecurityDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/history" 
              element={
                <ProtectedRoute>
                  <VisitorHistory />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute>
                  <UserManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/security/registry" 
              element={
                <ProtectedRoute>
                  <VisitorRegistry />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/security-registries" 
              element={
                <ProtectedRoute>
                  <SecurityRegistryHistory />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/qr-debug" 
              element={<QRDebug />} 
            />
            <Route 
              path="/test-scanner" 
              element={<TestScanner />} 
            />
            <Route 
              path="/security/scanned" 
              element={
                <ProtectedRoute>
                  <SecurityScannedHistory />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/security/visitors" 
              element={
                <ProtectedRoute>
                  <SecurityVisitorRegistry />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/support" 
              element={
                <ProtectedRoute>
                  <SupportForm />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/support-messages" 
              element={
                <ProtectedRoute>
                  <SupportMessages />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/properties" 
              element={
                <ProtectedRoute>
                  <PropertyManagement />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;